import { z } from 'zod'
import { OptionalString, toInterval } from '@/shared/api'

/**
 * Что видно снаружи. Наружу не уходят ни числа занятости, ни состав команды,
 * ни соседние выходы, ни даже идентификатор — только название, время, точка
 * сбора и «есть места» (`PublicExposure`, `SeatsAvailability`).
 */
export const PublicExcursionSchema = z
  .object({
    title: z.string(),
    starts_at: z.iso.datetime(),
    ends_at: z.iso.datetime(),
    meeting_point: OptionalString,
    seats_available: z.boolean(),
    cancelled: z.boolean(),
    cancellation_reason: OptionalString,
    /**
     * Формулировку согласия отдаёт сервер: за неё отвечает закон, и держать её
     * в браузерном бандле нельзя — покажем ровно то, что сохранится в журнале.
     */
    consent_wording: z.string(),
  })
  .transform((dto) => ({
    title: dto.title,
    slot: toInterval({ starts_at: dto.starts_at, ends_at: dto.ends_at }),
    meetingPoint: dto.meeting_point,
    seatsAvailable: dto.seats_available,
    cancelled: dto.cancelled,
    cancellationReason: dto.cancellation_reason,
    consentWording: dto.consent_wording,
  }))

export type PublicExcursion = z.infer<typeof PublicExcursionSchema>

export const BookingConfirmationSchema = z
  .object({
    booking_id: z.uuid(),
    title: z.string(),
    starts_at: z.iso.datetime(),
    ends_at: z.iso.datetime(),
    meeting_point: OptionalString,
  })
  .transform((dto) => ({
    bookingId: dto.booking_id,
    title: dto.title,
    slot: toInterval({ starts_at: dto.starts_at, ends_at: dto.ends_at }),
    meetingPoint: dto.meeting_point,
  }))

export type BookingConfirmation = z.infer<typeof BookingConfirmationSchema>

export interface PublicBookingInput {
  excursionId: string
  token: string
  name: string
  phone: string
  seats: number
  note: string
  consentGiven: boolean
}
